import React from 'react';
import { Box, Typography, Button, Grid, useTheme } from '@mui/material';
import { AdaptiveContainer } from './index';
import { Link } from 'react-router-dom';

const InfoSection = ({
  title,
  children,
  illustration,
  illustrationAlt,
  primaryButton,
  secondaryButton,
  thirdButton,
  backgroundColor,
  cardBackground,
  titleColor,
  textColor,
  ...props
}) => {
  const theme = useTheme();

  return (
    <Box sx={{ 
      backgroundColor: backgroundColor || theme.palette.background.default
    }} {...props}>
      <AdaptiveContainer>
        <Box
          sx={{
            backgroundColor: cardBackground || theme.palette.background.paper,
            borderRadius: 1,
            boxShadow: theme.shadows[4],
            overflow: "hidden",
            width: "100%",
          }}
        >
          {/* Layout simple avec flexbox */}
          <Box sx={{ 
            display: 'flex',
            flexDirection: { xs: 'column-reverse', md: 'row' },
            minHeight: { md: 'auto' }
          }}>
            
            {/* Colonne texte - 75% sur desktop */}
            <Box sx={{ 
              flex: { xs: '1', md: '3.2' },
              p: { xs: 3, md: 4, lg: 4 },
              py: { xs: 3, md: 3, lg: 3 },
            //   display: 'flex',
            //   flexDirection: 'column',
            //   justifyContent: 'center'
            }}>
              {/* Titre */}
              <Typography
                variant="h4"
                component="h2"
                sx={{
                  fontWeight: 600,
                  color: titleColor || theme.palette.primary.main,
                  mb: 1,
                  fontSize: { xs: "1.5rem", md: "1.75rem" },
                  lineHeight: 1.2,
                }}
              >
                {title}
              </Typography>
              
              {/* Contenu personnalisable */}
              <Box sx={{ 
                mb: 4, 
                color: textColor || theme.palette.text.secondary,
                '& .MuiTypography-root': {
                  color: textColor || theme.palette.text.secondary,
                }
              }}>
                {children}
              </Box>

              {/* Boutons */}
              {(primaryButton || secondaryButton || thirdButton) && (
                <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" ,flexDirection: { xs: 'column', md: 'row' }     }}>
                  {secondaryButton && (
                    <Button
                      component={Link}
                      variant="secondary"
                      type="link"
                      onClick={secondaryButton.onClick}
                      to={secondaryButton.onClick}
                      sx={{
                        px: 3,
                        py: 1.2,
                        borderRadius: 1,
                        textTransform: "none",
                        fontWeight: 500,
                        fontSize: "0.95rem",
                      }}
                    >
                      {secondaryButton.text}
                    </Button>
                  )}
                  
                  {primaryButton && (
                    <Button
                      component={Link}
                      variant="primary"
                      type="link"
                      to={primaryButton.to}
                      // onClick={ primaryButton.onClick}

                      sx={{
                        px: 3,
                        py: 1.2,
                        borderRadius: 1,
                        textTransform: "none",
                        fontWeight: 500,
                        fontSize: "0.95rem",
                      }}
                    >
                      {primaryButton.text}
                    </Button>
                  )}

                  {thirdButton && (
                    <Button
                    component={Link}
                      variant="primary"
                      type="link"
                      to={thirdButton.to}
                      onClick={thirdButton.onClick}
                      
                      color="secondary"
                      sx={{
                        px: 3,
                        py: 1.2,
                        borderRadius: 1,
                        textTransform: "none",
                        fontWeight: 500,
                        fontSize: "0.95rem",
                      }}
                    >
                      {thirdButton.text}
                    </Button>
                  )}
                </Box>
              )}
            </Box>

            {/* Colonne image - 25% sur desktop */}
            <Box sx={{ 
              flex: { xs: '1', md: '0.9' },
              background: "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              p: { xs: 3, md: 2 },
              minHeight: { xs: 200, md: 'auto' }
            }}>
              {illustration && (
                <Box
                  component="img"
                  src={illustration}
                  alt={illustrationAlt || title}
                  sx={{
                    width: "100%",
                    maxWidth: { xs: 200, md: 180 },
                    height: "auto",
                    objectFit: "contain",
                  }}
                />
              )}
            </Box>
          </Box>
        </Box>
      </AdaptiveContainer>
    </Box>
  );
};

export default InfoSection; 